import { Title, Text, FieldsetTitle, Input, InputButton } from '@components/forms/InputPartials.tsx';
import { type FC, type FormEvent, type ReactElement, useState } from 'react';
import { SubmitForm } from '@pages/Contact/forms/SubmitForm.tsx';
import { SubmitMessage } from '@pages/Contact/components/SubmitMessage.tsx';
import { NoticeError } from '@components/forms/NoticeError.tsx';
import type { UsatourDate } from '@pages/Usa/UsaPage.tsx';

type Props = {
  defaultSubmitted?: boolean;
  onSuccess?: () => void;
  tourId?: string;
  location?: string;
  tourDate: UsatourDate | null;
};

const CampaignSignup: FC<Props> = ({
  defaultSubmitted = false,
  onSuccess,
  tourId,
  location,
  tourDate,
}): ReactElement => {
  const [submitted, setSubmitted] = useState(defaultSubmitted);
  const [error, setError] = useState<string>('');
  const handleSubmit = (e: FormEvent) => {
    SubmitForm(
      e,
      '/api/usa_2026/sign_up',
      () => {
        setSubmitted(true);
        if (onSuccess) onSuccess();
      },
      (message: string) => {
        setError(message);
      },
    );
  };

  if (submitted) {
    return (
      <SubmitMessage
        title="Access granted."
        text="Details are coming.

Date, Venue & Ticket information are headed your way!"
      />
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      onChange={() => setError('')}
    >
      {tourId && (
        <input
          type="hidden"
          name="tour_id"
          value={tourId}
        />
      )}
      {location && (
        <input
          type="hidden"
          name="location"
          value={location}
        />
      )}
      <Title>{tourDate?.campaign_title || 'HARDWELL. USA. JUNE 2026.'}</Title>
      {tourDate?.campaign_text ? (
        <Text>
          <span dangerouslySetInnerHTML={{ __html: tourDate.campaign_text }} />
        </Text>
      ) : (
        <Text>
          Last year we went coast 2 coast, and this year I’m back for more.
          <br />
          Register now to be the first to know the details on all cities AND for your guaranteed early access to tickets
          🎫 🎟️ <br />
          <br />
          Are you with me?!
        </Text>
      )}
      <div className="tw-grid tw-grid-cols-1 tw-gap-4">
        {tourDate && (
          <div className="tw-mt-8 tw-text-lg  tw-text-center tw-uppercase tw-font-display">
            <span className="tw-text-gray-700 ">Register for:</span>{' '}
            <span className="tw-font-display tw-text-black">{tourDate.location}</span>
          </div>
        )}
        <FieldsetTitle className="tw-col-span-1 tw-mt-8">Your information</FieldsetTitle>
        <Input
          name="name"
          type="text"
          placeholder="Full name"
          required={true}
        />
        <Input
          name="email"
          type="email"
          placeholder="Email address"
          required={true}
        />
        <Input
          name="signup"
          className="tw-col-span-1 "
          type="checkbox"
          label="I’d like to receive news and updates from Hardwell."
        />
        <InputButton
          type="submit"
          className="tw-col-span-1  tw-mt-12"
        >
          Submit
        </InputButton>
      </div>
      {error && (
        <div className="tw-grid tw-grid-cols-1 tw-gap-4">
          <NoticeError>{error}</NoticeError>
        </div>
      )}
    </form>
  );
};

export default CampaignSignup;
